export default "__VITE_ASSET__Hczp2zsz__"